import { useEffect } from "react";

import { useNavigate } from "utils/routing";

// Legacy route shim: keep for backward compatibility and redirect to /section.
export default function Layout() {
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = window.location;
    const redirectedPath = pathname.replace(/^\/course(\/|$)/, "/section$1");
    navigate(`${redirectedPath}${search}${hash}`);
  }, [navigate]);

  return null;
}
